module.exports = __webpack_public_path__ + "img/logo-riva_green.e48228d5.svg";